/** @returns {string} */
export function newRegistryEntryId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return `re_${crypto.randomUUID()}`;
  }
  return `re_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

/** @returns {string} */
export function newRoomMemberId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return `rm_${crypto.randomUUID()}`;
  }
  return `rm_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}
